import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-user-variables',
    name: 'pay-user-variable',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-user-variable')
  }
]
